import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayonlineService {
  token = ""
  overallDue = "/student/v2/razorpaySearch"

  constructor(private http: HttpClient) { }

  getOverallDueDetails(data: any): Observable<any> {
    return this.http.post(environment.apiCalls + '/student/v2/payments/razorpaySearch', data);
  }

  createOrderDetails(data: any): Observable<any> {
    return this.http.post(environment.apiCalls + '/student/v2/payments/createRazorpayOrder', data);
  }


  paymentDetails(data: any): Observable<any> {
    return this.http.post(environment.apiCalls + '/student/v2/payments/doRazorpayPayment', data);
  }


  downloadPdf(data: any) {
    const url = `${environment.apiCalls}/student/v2/payments/generatePayOnlinePdf?encryptReferenceId=${data}`;
    return this.http.get(url, { responseType: 'blob' });
  }


}
